import { Card } from 'ui/index'
import {
  BANCOR_URL,
  BITTREX_URL,
  UNISWAP_URL
} from 'config/constants'

import { ReactComponent as UniswapSVG } from 'assets/images/flixx/uniswap.svg'
import { ReactComponent as BancorSVG } from 'assets/images/flixx/bancor.svg'
import { ReactComponent as BittrexSVG } from 'assets/images/flixx/bittrex.svg'

import LinkExchange from './LinkExchange'


const index = () => {
  return (
    <Card
      borderRadius={16}
      display='grid'
      placeItems='center'
      height='100vw'
      maxHeight={376}
      minHeight={357}

    >
      <Card
        variant='secondary'
        borderRadius={12}
        display='flex'
        flexDirection='column'
        gap={16}
        alignItems='center'
        justifyContent='center'
        width='fit-content'
        height={261}
        padding={16}
      >
        <LinkExchange to={BITTREX_URL}>
          <BittrexSVG />
        </LinkExchange>

        <LinkExchange to={BANCOR_URL}>
          <BancorSVG />
        </LinkExchange>

        <LinkExchange to={UNISWAP_URL}>
          <UniswapSVG />
        </LinkExchange>
      </Card>
    </Card>
  )
}

export default index